; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.cartcommon = {
        name: 'cartcommon', //nom à modifier
        version: '1.0.0',
        settings: {
            callback: function () { }
        },
        windowSize: {
            width: $(window).width(),
            height: $(window).height()
        },
        init: function (scope, method, options) {
            // initialisation à conserver
            // TODO : voir si utile
            Foundation.inherit(this, 'throttle random_str');
            var self = this;

            this.settings = this.settings || $.extend({}, this.defaults, (options || method));

            // à conserver
            this.bindings(method, options);
        },
        events: function () {
            // initialisation pratique à conserver
            var self = this;
            var S = this.S;

            this.initBindings();

            $(window)
                .off('.cart-common')
                .on('resize.fndtn.recapitulatif', self.throttle(function () {

                    this.windowSize = {
                        width: $(window).width(),
                        height: $(window).height()
                    };

                }, 100));
        },
        

        initBindings: function () {
            $(this.scope)
                .off('.cart-common')
                // BIND SCROLL POUR SUIVI DU RESUME
                .on('scroll.fndtn.paiement', this.throttle(function (e) {

                }).bind(this))
                // BIND SCROLL POUR SUIVI DU RESUME (Non classe à changer)
                .on('scroll.fndtn.cart', this.throttle(function (e) {
                    var scrolltop = $(document).scrollTop();
                    if (matchMedia(Foundation.media_queries.large).matches) {
                        if ($(".o-summary").length) {
                            self.limits.bottom = $("#main-footer").offset().top;

                            var height = $(".o-summary").height();
                            var margin = 10;

                            if ((scrolltop > self.limits.top) && (scrolltop + height < self.limits.bottom - margin * 2)) {
                                $(".o-summary").stop().animate({ top: scrolltop - self.limits.top + margin })
                            } else if (scrolltop + height >= self.limits.bottom - margin * 2) {
                                return;
                            } else {
                                $(".o-summary").stop().animate({ top: 0 })
                            }
                        }
                    }
                    if ($(".t-cart__columns>.m-headerCart").length) {
                        if (!matchMedia(Foundation.media_queries.large).matches && !matchMedia(Foundation.media_queries.medium).matches) {
                            if (scrolltop > $(".m-headerLayoutCart").height()) {
                                $(".t-cart__columns>.m-headerCart").addClass("-fixed");
                            } else {
                                $(".t-cart__columns>.m-headerCart").removeClass("-fixed");
                            }
                            if (scrolltop + $(window).height() > $('.m-summary').offset().top + $('.m-summary').height()) {
                                $(".t-cart__columns>.m-headerCart").hide();
                            } else {
                                $(".t-cart__columns>.m-headerCart").show();
                            }

                        } else {
                            $(".t-cart__columns>.m-headerCart").removeClass("-fixed");
                        }
                    }
                }).bind(this))
                .on('click', '.fbo', (function (event) {
                    event.preventDefault();
                    var urlContent = this.attributes["data-href"];

                    var urlDecode = decodeURIComponent(window.atob(urlContent.value));

                    window.location.href = urlDecode;
                }).bind(this))
                ;
        },
        moveCursorToEnd: function (input) {
            var originalValue = input.val();
            input.val('');
            input.blur().focus().val(originalValue);
        },
        refreshSvgGiftCardPreview: function () {
            for (var i = 1; i <= 10; i++) {
                $("#giftPackageLinePreview" + i).html($("#Line" + i).val());
            }

            $('#giftPackageSvgPreview').html($('#giftPackageSvgPreview').html());
        },
        initFullScreenZoom: function () {
            // Gestion du Zoom en popin fullscreen
            var zoomRevealSettings = {
                close_on_background_click: true,
                close_on_esc: true,
                dismiss_modal_class: 'close-reveal-modal',
                bg_class: 'reveal-modal-bg'
            };
        },
        stopPreloader: function () {
            Foundation.libs.common.hidePreloader();
        },
      
        onScrollResumeValidateSectionMobilePosition: function () {
            if (window.innerWidth <= 1024) {
                const target = document.querySelector('.summary__total.-desktop');
                const mobileTotal = document.querySelector('.summary__total.-mobile.-isSticky');
                if (target !== null && !target.classList.contains('-initializated')) {
                    target.classList.add('-initializated')
                    target.style.height = mobileTotal.getBoundingClientRect().height - 10 + 'px';

                    let options = {
                        root: document.querySelector('document'),
                        rootMargin: (mobileTotal.getBoundingClientRect().height - 10) * -1 + "px",
                        treshold: 1.0,
                    }
                    function handleIntersection(entries) {
                        entries.map((entry) => {
                            if (entry.isIntersecting) {
                                mobileTotal.classList.add('-nofix')
                            } else {
                                mobileTotal.classList.remove('-nofix')
                            }
                        });
                    }
                    const observer = new IntersectionObserver(handleIntersection, options);
                    observer.observe(target);
                }
            }
        },
        onClickShowRecapMobile: function () {   
            let showMobileRecapBtn = $('#showMobileRecap');
            let recapMobileContent = $('.summary__total.-mobile .total__details');

            showMobileRecapBtn.on('click', () => {
                recapMobileContent.toggleClass('-active');
                showMobileRecapBtn.toggleClass('-active');

                let heightRecapChild = 0;
                recapMobileContent.children().each(function (el) {
                    heightRecapChild += recapMobileContent.children()[el].getBoundingClientRect().height;
                }) 

                recapMobileContent.hasClass('-active')
                    ? recapMobileContent.css('height', heightRecapChild + 'px')
                    : recapMobileContent.css('height', 0)
            })
        },

        InitGlobal: function () {
            Foundation.libs.cartcommon.onScrollResumeValidateSectionMobilePosition();
            Foundation.libs.cartcommon.onClickShowRecapMobile();
        }
    };
}(jQuery, this, this.document));

$(window).resize(function () {
    Foundation.libs.cartcommon.onScrollResumeValidateSectionMobilePosition();
})

$(document).ready(function () {
    Foundation.libs.cartcommon.onScrollResumeValidateSectionMobilePosition();
    Foundation.libs.cartcommon.onClickShowRecapMobile();
})
